import { Spin } from "antd"
import React from "react"

const Loader = () => {
  return (
    <div className="loader">
      <Spin size="large" />
    </div>
  )
}

export default Loader
